/** Prefix/suffix UTF-16 diff (aligned with iOS `WaveTextDiff`). */
export function computeTextEdit(oldText, newText) {
    if (oldText === newText)
        return null;
    // JS strings index UTF-16 code units (aligned with iOS NSString / UITextView).
    let prefix = 0;
    const minLen = Math.min(oldText.length, newText.length);
    while (prefix < minLen &&
        oldText.charCodeAt(prefix) === newText.charCodeAt(prefix)) {
        prefix += 1;
    }
    let suffix = 0;
    while (suffix < minLen - prefix &&
        oldText.charCodeAt(oldText.length - 1 - suffix) ===
            newText.charCodeAt(newText.length - 1 - suffix)) {
        suffix += 1;
    }
    const deleteCount = oldText.length - prefix - suffix;
    const insert = newText.slice(prefix, newText.length - suffix);
    return { start: prefix, deleteCount, insert };
}
